// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as UAParser$OrcaPaymentPage from "./libraries/ua-parser-js/UAParser.bs.js";

function checkIsSafari() {
  let userAgentString = navigator.userAgent;
  let chromeAgent = userAgentString.indexOf("Chrome") > -1;
  let safariAgent = userAgentString.indexOf("Safari") > -1;
  if (chromeAgent) {
    return false;
  } else {
    return safariAgent;
  }
}

let date = new Date();

function broswerInfo() {
  let data = UAParser$OrcaPaymentPage.make();
  let osType = Core__Option.getOr(data.os.name, "Unknown");
  let osVersion = Core__Option.getOr(data.os.version, "Unknown");
  let deviceModel = Core__Option.getOr(data.device.model, "Unknown Device");
  let colorDepth = [
    1,
    4,
    8,
    15,
    16,
    24,
    32,
    48
  ].includes(screen.colorDepth) ? screen.colorDepth : 24;
  return [[
      "browser_info",
      Utils$OrcaPaymentPage.getJsonFromArrayOfJson([
        [
          "user_agent",
          navigator.userAgent
        ],
        [
          "accept_header",
          "text\/html,application\/xhtml+xml,application\/xml;q=0.9,image\/webp,image\/apng,*\/*;q=0.8"
        ],
        [
          "language",
          navigator.language
        ],
        [
          "color_depth",
          colorDepth
        ],
        [
          "screen_height",
          screen.height
        ],
        [
          "screen_width",
          screen.width
        ],
        [
          "time_zone",
          date.getTimezoneOffset()
        ],
        [
          "java_enabled",
          true
        ],
        [
          "java_script_enabled",
          true
        ],
        [
          "device_model",
          deviceModel
        ],
        [
          "os_type",
          osType
        ],
        [
          "os_version",
          osVersion
        ]
      ])
    ]];
}

export {
  checkIsSafari,
  date,
  broswerInfo,
}
/* date Not a pure module */
